<template>
  <div class="fragebogenHeader">
    <v-row class="pl-3">
      <v-col class="pa-1">
        <h2>
          {{ projekt ? projekt.titel : '' }}
        </h2>
      </v-col>
    </v-row>
    <v-row class="pb-3">
      <v-col cols="auto" class="pa-0 pl-6">
        <v-row>
          <v-col class="pa-1">
            <b>Verbundsprojekt: </b>
          </v-col>
        </v-row>
        <v-row>
          <v-col class="pa-1">
            <b>Teilvorhaben: </b>
          </v-col>
        </v-row>
        <v-row>
          <v-col class="pa-1">
            <b>FKZ: </b>
          </v-col>
        </v-row>
        <v-row>
          <v-col class="pa-1">
            <b>Projektleitung: </b>
          </v-col>
        </v-row>
        <v-row>
          <v-col class="pa-1">
            <b>Akronym: </b>
          </v-col>
        </v-row>
      </v-col>

      <v-col cols="auto" class="pa-0 pl-6 pr-6">
        <v-row>
          <v-col class="pa-1">
            {{
              projekt ? projekt.titelVerbund : ''
            }}
          </v-col>
        </v-row>
        <v-row>
          <v-col class="pa-1">
            {{
              projekt
                ? projekt.titelTeilvorhaben
                : ''
            }}
          </v-col>
        </v-row>
        <v-row>
          <v-col class="pa-1">
            {{
              projekt
                ? projekt.foerderkennzeichen
                : ''
            }}
          </v-col>
        </v-row>
        <v-row>
          <v-col class="pa-1">
            {{ projektleiter }}
          </v-col>
        </v-row>
        <v-row>
          <v-col class="pa-1">
            {{ projekt ? projekt.acronym : '' }}
          </v-col>
        </v-row>
      </v-col>

      <!-- Anzeige, ob und wann der Fragebogen bereits ausgefüllt wurde -->
      <template
        v-if="
          fragebogen.zwischenstand &&
          this.$router.currentRoute.name == 'fragebogenAusfuellen' &&
          fragebogen.zwischenstand.letzteÄnderung != null &&
          !abgeschickt && fragebogen.zwischenstand.position > 2
        "
      >
        <v-spacer />
        <v-col class="pa-0 pl-6 pr-6">
          <v-row class="pa-3 kasten" align="center">
            <v-col cols="auto">
              <v-icon x-large>mdi-exclamation</v-icon>
            </v-col>
            <v-col>
              <p>
                Dieser Fragebogen wurde bereits am
                {{ letzteAenderung }} ausgefüllt. Neue Einträge können
                hinzugefügt und geändert werden. Bereits ausgefüllte
                Felder die zu einem früheren Zeitpunkt abgeschickt wurden
                können jedoch nicht weiter bearbeitet werden.
              </p>
            </v-col>
          </v-row>
        </v-col>
      </template>

      <!-- Zusantzinformationen über letzte Änderungen -->
      <v-col v-if="isletzteAenderung()" align-self="end" class="pa-0 pl-6 pr-6">
        <v-row justify="end">
          <v-col cols="auto" class="pa-0">
            <v-row>
              <v-col class="pa-1">
                <b>Erstellt: </b>
              </v-col>
            </v-row>
            <v-row>
              <v-col class="pa-1">
                <b>Versendet: </b>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="auto" class="pa-0 pl-6 pr-6">
            <v-row>
              <v-col class="pa-1">
                {{ erstellt }}
              </v-col>
            </v-row>
            <v-row>
              <v-col class="pa-1">
                {{ versendet }}
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="auto" align-self="end" class="pa-0 pr-3">
            <v-row>
              <v-col class="pa-1">
                <b>Ausgefüllt: </b>
              </v-col>
              <v-col class="pa-1">
                {{ letzteAenderung }}
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </div>
</template>
<script>
import dataMixin from '@/mixins/data-mixin';
import dateFormatService from '../../service/date-format-service';

export default {
  components: {},
  name: 'FragebogenHeader',
  props: {
    projekt: {
      type: Object,
      required: true,
    },
    abgeschickt: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    projektleiter: function () {
      if (this.projekt) {
        if (
          this.projekt.projektLeiter.vorname == undefined ||
          this.projekt.projektLeiter.nachname == undefined
        )
          return ' ';
        else if (this.projekt.projektLeiter.titel == undefined)
          return (
            this.projekt.projektLeiter.vorname +
            ' ' +
            this.projekt.projektLeiter.nachname
          );
        else
          return (
            this.projekt.projektLeiter.titel +
            ' ' +
            this.projekt.projektLeiter.vorname +
            ' ' +
            this.projekt.projektLeiter.nachname
          );
      } else {
        return '';
      }
    },
    letzteAenderung: function () {
      if (this.fragebogen.zwischenstand) {
        return dateFormatService.formatDate(
          new Date(this.fragebogen.zwischenstand.letzteÄnderung)
        );
      } else {
        return '';
      }
    },
    erstellt: function () {
      return dateFormatService.formatDate(new Date(this.fragebogen.erstellt));
    },
    versendet: function () {
      return dateFormatService.formatDate(new Date(this.fragebogen.versendet));
    },
  },
  mixins: [
    dataMixin('fragebogen', 'loadedData.fragebogen', {}),
  ],
  methods: {
    isletzteAenderung() {
      if (this.fragebogen.zwischenstand) {
        return (
          this.$router.currentRoute.name ===
            'fragebogenZwischenstandUebersicht' &&
          this.fragebogen.zwischenstand.letzteÄnderung
        );
      } else {
        return false;
      }
    },
  },
};
</script>
<style lang="scss">
.kasten {
  border: solid;
  border-radius: 8px;
  border-width: 1px;
  border-color: #8a8a8a;
  height: 100%;
  margin-bottom: 0px;
  background: #fff;
}
</style>